import React from 'react';
import { button as buttonStyles, buttonSizes } from '../../utils/designTokens';

/**
 * Button - Consistent button component
 * Variants: primary, secondary, danger, ghost
 * Sizes: sm, default, lg
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'default',
  type = 'button',
  disabled = false,
  onClick,
  className = '',
  icon: Icon,
  iconPosition = 'left',
  ...props
}) => {
  const variantClass = buttonStyles[variant] || buttonStyles.primary;
  const sizeClass = buttonSizes[size] || buttonSizes.default;
  const disabledClass = disabled ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${variantClass} ${sizeClass} ${disabledClass} inline-flex items-center justify-center gap-2 ${className}`}
      {...props}
    >
      {Icon && iconPosition === 'left' && <Icon className="text-lg" />}
      {children}
      {Icon && iconPosition === 'right' && <Icon className="text-lg" />}
    </button>
  );
};

export default Button;
